import React from 'react';
import { motion } from 'framer-motion';
export function ObjectionsSection() {
  return <section className="py-20 md:py-28 bg-[#0A0A0A] text-[#FAF7F2]" data-id="element-196">
      <div className="max-w-3xl mx-auto px-4" data-id="element-197">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-10" data-id="element-198">
          <h2 className="text-2xl md:text-3xl font-bold font-serif text-[#C5A55A]" data-id="element-199">
            🧨 Puedes llegar a pensar...
          </h2>
        </motion.div>

        <div className="space-y-10" data-id="element-200">
          {/* Objection 1 */}
          <motion.div className="border-l-2 border-[#C5A55A]/40 pl-6" initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} data-id="element-201">
            <p className="text-lg md:text-xl font-bold text-[#FAF7F2] mb-3" data-id="element-202">
              ❓ "Mi relación no está tan mal."
            </p>
            <p className="text-[#FAF7F2]/70 text-lg font-light leading-relaxed" data-id="element-203">
              Eso dicen todas antes de que esté peor.
            </p>
            <p className="text-[#FAF7F2]/70 text-lg font-light" data-id="element-204">
              Las relaciones no colapsan. Se enfrían lentamente.
            </p>
          </motion.div>

          {/* Objection 2 */}
          <motion.div className="border-l-2 border-[#C5A55A]/40 pl-6" initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-205">
            <p className="text-lg md:text-xl font-bold text-[#FAF7F2] mb-3" data-id="element-206">
              ❓ "Mi pareja no va a querer verlo."
            </p>
            <p className="text-[#FAF7F2]/70 text-lg font-light leading-relaxed" data-id="element-207">
              Empieza tú.
            </p>
            <p className="text-[#FAF7F2]/70 text-lg font-light" data-id="element-208">
              Cuando la energía íntima cambia, la dinámica cambia.
            </p>
          </motion.div>

          {/* Objection 3 */}
          <motion.div className="border-l-2 border-[#C5A55A]/40 pl-6" initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} data-id="element-209">
            <p className="text-lg md:text-xl font-bold text-[#FAF7F2] mb-3" data-id="element-210">
              ❓ "No tenemos tiempo."
            </p>
            <p className="text-[#FAF7F2]/70 text-lg font-light leading-relaxed" data-id="element-211">
              Si no tienes 90 minutos para tu relación, esa es la señal más
              clara de alerta.
            </p>
          </motion.div>

          {/* Objection 4 */}
          <motion.div className="border-l-2 border-[#C5A55A]/40 pl-6" initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} data-id="element-212">
            <p className="text-lg md:text-xl font-bold text-[#FAF7F2] mb-3" data-id="element-213">
              ❓ "Seguro son solo técnicas."
            </p>
            <p className="text-[#FAF7F2]/70 text-lg font-light leading-relaxed" data-id="element-214">
              No. Es reconexión emocional + activación corporal + dirección
              íntima.
            </p>
            <p className="text-[#FAF7F2]/70 text-lg font-light" data-id="element-215">
              No es performance. Es vínculo.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}